import request from './request';
/**
 *  店铺辐射车辆
 */
export function getRadialVehicle(params) {
    return request('/stat/driving/org-radiation-vehicles', {
        method: 'GET',
        params,
        timeout: 120 * 1000,
        headers: {
            'Cancel-Message': true,
        },
    });
}
